module.exports = __webpack_public_path__ + "_assets/img/delete2.67e8e7e2.svg";